import { ImagePostModalComponent } from "@circle-react/components/Spaces/ImageSpace/ImagePostModalCompass/ImagePostModalComponent";
import type { ComponentPropsWithoutRef } from "react";

import {
  ModalManager,
  useModal,
} from "@/react/components/Layout/ModalManagerProvider";
import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { ImagePostModalUIKitComponent } from "./ImagePostModalUIKitComponent";

type ImagePostModalProps = ComponentPropsWithoutRef<
  typeof ImagePostModalUIKitComponent
>;

const ImagePostModalUIKit = ModalManager.create(
  (props: ImagePostModalProps) => <ImagePostModalUIKitComponent {...props} />,
);

const ImagePostModalCompass = ModalManager.create(
  (props: ImagePostModalProps) => {
    const modal = useModal();

    return (
      <ImagePostModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const useImagePostModal = () => {
  const isCircleV4ModalsEnabled = useIsCircleV4FeatureEnabled(
    "circle_v4_modals_enabled",
    { requireAdminArea: false },
  );

  return useModal(
    isCircleV4ModalsEnabled ? ImagePostModalCompass : ImagePostModalUIKit,
  );
};
